import "core-js/modules/es.array.find";
import _typeof from "/Users/dfravel/Projects/degreedata-wp/wp-content/plugins/dd-search/vue/node_modules/@babel/runtime/helpers/esm/typeof";

function inserted(el, binding) {
  var modifiers = binding.modifiers ||
  /* istanbul ignore next */
  {};
  var value = binding.value;
  var isObject = _typeof(value) === 'object';
  var callback = isObject ? value.handler : value;
  var observer = new IntersectionObserver(function () {
    var entries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var observer = arguments.length > 1 ? arguments[1] : undefined;

    /* istanbul ignore if */
    if (!el._observe) return; // Just in case, should never fire
    // If is not quiet or has already been
    // initted, invoke the user callback

    if (callback && (!modifiers.quiet || el._observe.init)) {
      var isIntersecting = Boolean(entries.find(function (entry) {
        return entry.isIntersecting;
      }));
      callback(entries, observer, isIntersecting);
    } // If has already been initted and
    // has the once modifier, unbind


    if (el._observe.init && modifiers.once) unbind(el); // Otherwise, mark the observer as initted
    else el._observe.init = true;
  }, value.options || {});
  el._observe = {
    init: false,
    observer: observer
  };
  observer.observe(el);
}

function unbind(el) {
  /* istanbul ignore if */
  if (!el._observe) return;

  el._observe.observer.unobserve(el);

  delete el._observe;
}

export var Intersect = {
  inserted: inserted,
  unbind: unbind
};
export default Intersect;